import axios from "@/libsSettings/axios";
export default  async function getAll(ids, base64) {
  const param = (base64 ? window.atob(base64) : (ids ? ids : ''));
  let url = (param ? '/productcompare/apiV2/index/?ids=' + param : '/productcompare/apiV2/index/');
  // const url = 'compare.json';
  const res = await axios(url);
  const resData = await res.data;

  // Прокидываем скрипты в шапку
  if (
      resData.extra_meta &&
      resData.extra_meta.length > 0
  ) {
    for (const url of resData.extra_meta) {
        document.head.insertAdjacentHTML('beforeend', resData.extra_meta)
    }
  }
  // Прокидываем скрипты в шапку и  футер
  if (
      resData.extra_scripts &&
      resData.extra_scripts.length > 0
  ) {
    for (const url of resData.extra_scripts) {
      let script = document.createElement('script');
      script.setAttribute('src', url);
      document.head.appendChild(script);
      console.log('🐌 Loading script ' + url);
    }
  }
  if (
      resData.extra_scripts_footer &&
      resData.extra_scripts_footer.length > 0
  ) {
    for (const url of resData.extra_scripts_footer) {
      let script = document.createElement('script');
      script.setAttribute('src', url);
      document.body.appendChild(script);
      console.log('🐌 Loading script ' + url);
    }
  }

  return resData;
}
